// IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса под ключ — Z5 по умолчанию; BE ie-dm7 stock_cells_batch)
// Виды ячеек строк запаса Баланса (эскизы stock3.html — Z1–Z6, stock4.html — группы A–F). Чистые функции без Vue и DOM: распознавание строк
// запаса в дереве _doc.data, параметры и слияние ответа метода виджета stock_cells_batch (контракт ie-dm7 handoff-tools/2026-11-03/stock_cells/
// contract.md §4), модель ячейки, реестр рендеров STOCK_VIEWS и режимов групп STOCK_GROUP_MODES, сборка SVG-слоя (data-URI фона ячейки).
// Обвязка — AttrGrid.vue stk_* (фоновая загрузка порциями, как предзагрузка сигналов; пост-шаг formatItem_fast — оба пути отрисовки).
//
// Строка запаса: собственный или унаследованный отбор _DLRow.where measure_type = open_balance (корень — «Запас на початок»), дети — subject_type →
// … → subject (GUID). Строки ниже листа-субъекта и строки, у которых subject — подпись (не GUID), — псевдострочки («· of which expired», «Stock cover»):
// их не шлём и не рисуем. object — ближайший отбор object строки или предков. path — индексный путь строки в _doc.data (как у select_cell_views).
//
// Кривая ячейки (контракт §4 «Что фронту учесть», п. 1): не по open[i+1] − open[i] + out, а по полям ответа — вход start → пик start + in (середина
// месяца) → выход end_raw (end − short; < 0 — OOS). Высота — по порогам min / opt / max / excess той же строки (шкала вида), цвет последнего отрезка —
// по zone ответа (или zone_engine — опция fe.ux.stockZoneSource), остальные отрезки — по порогам. Монохром: цвет только у OOS / Critical / Over-norm.
//
// РЕНДЕР — чистая функция (cell, neighbours, rowScale, size) → { layers, title }: cell — stockCell_model, layers — примитивы в единицах эскиза
// (W 110 × H 26), stockCell_svg переводит их в пиксели ячейки. Новый вид — одна запись в STOCK_VIEWS (следующий шаг: P / P2 / Q / R / S / T / U /
// U2 / U4 / U5), новый режим группы — одна запись в STOCK_GROUP_MODES (позже G1–G5) и пункт в реестре displayOptions.
import { t as tI18n } from '@/i18n'
import { stockGroupModes2_modes, stockGroupCalm_read } from './stockGroupModes2'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: объединение зон групп складов G1–G5; BE n_by_zone #1013)
import { STOCK_ZONE_CTX } from './stockZones.js'   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р6/Р7): названия зон подсказки — контекст словаря «stock zone»
import { stockViews2, STOCK_VIEW2_IDS, stockRow_scale } from './stockCellViews2.js'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса P/P2/Q/R/S/T/U/U2/U4/U5)

export const STOCK_CELLS_METHOD = 'stock_cells_batch'
export const STOCK_VIEW_FLAG = 'fe.ux.stockCellView'
export const STOCK_GROUP_FLAG = 'fe.ux.stockGroupMode'
export const STOCK_ZONE_SRC_FLAG = 'fe.ux.stockZoneSource'
export const STOCK_VIEW_DEFAULT = 'z5'
export const STOCK_GROUP_DEFAULT = 'f'
export const STOCK_ZONE_SRC_DEFAULT = 'zone'
export const STOCK_PORTION = 40            // строк в порции (потолок бэка 500 строк / 1 000 пар объект×субъект)
export const STOCK_PAIRS_MAX = 1000
export const STOCK_BUDGET_MS = 3000
export const STOCK_DEBOUNCE_MS = 300
export const STOCK_RETRY_MAX = 2           // truncated строки — не больше двух повторов
export const STOCK_ERRORS_OFF = 2          // ошибок запроса подряд — выключиться до перезагрузки (старый бэк без метода)
export const STOCK_MEMO_MAX = 4000         // кеш слоёв ячеек
export const W = 110, H = 26, SPLIT = 0.5, ZB = 22   // единицы эскиза: ширина, высота, середина месяца, нулевая линия (ниже — OOS)

const isObj = (o) => !!o && typeof o === 'object' && !Array.isArray(o)
const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }
const f1 = (v) => Math.round(v * 10) / 10
const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
export const stock_isGuid = (v) => GUID_RE.test(str(v))
const NUM_ID_RE = /^[1-9]\d{0,17}$/   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129289): Demo7 — числовые id субъектов (1, 4, 5)
export const stock_isSubjectId = (v) => stock_isGuid(v) || NUM_ID_RE.test(str(v))   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129289): GUID или целое > 0; подписи псевдострочек — нет

// ---------- выключатели фронта: window.stockCells.get / set / reset (контракт §8: fe stockCells.visibleOnly) ----------
const FE_DEF = Object.freeze({ visibleOnly: true })
const FE = {}
export const STATS = { portions: 0, rows: 0, cells: 0, truncated: 0, missing: 0, stale: 0, aborted: 0, errors: 0, off: 0, busySkips: 0, memoHit: 0, memoMiss: 0, msSum: 0, beMsSum: 0 }
export const stockCells_fe = {
    get(k) { return Object.prototype.hasOwnProperty.call(FE, k) ? FE[k] : FE_DEF[k] },
    set(k, v) { FE[k] = v; return v },
    reset() { for (const k of Object.keys(FE)) delete FE[k] },
    stats: STATS,
}
if (typeof window !== 'undefined') window.stockCells = stockCells_fe
export function stockCells_stat(k, n = 1) { STATS[k] = (STATS[k] || 0) + n; return STATS[k] }

let OFF = ''
export function stockCells_off(reason = 'off') { if (!OFF) { OFF = String(reason || 'off'); STATS.offReason = OFF } return OFF }
export function stockCells_isOff() { return !!OFF }
export function stockCells_resetOff() { OFF = ''; delete STATS.offReason }   // только для тестов

// ---------- опции (реестр displayOptions) ----------
export { stockRow_scale }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса — общая шкала строки)
export const STOCK_VIEW_IDS = ['now', 'z1', 'z2', 'z3', 'z4', 'z5', 'z6', ...STOCK_VIEW2_IDS]   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса P/P2/Q/R/S/T/U/U2/U4/U5): p, p2, q, r, s, t, u, u2, u4, u5 — utils/stockCellViews2.js
export const STOCK_GROUP_IDS = ['a', 'b', 'c', 'd', 'e', 'f', 'g1', 'g2', 'g3', 'g4', 'g5']   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: объединение зон групп складов G1–G5; BE n_by_zone #1013)
export function stockCells_opts(setting) {
    const rd = (k, d) => { try { return typeof setting === 'function' ? setting(k, d) : d } catch (e) { return d } }
    const v = str(rd(STOCK_VIEW_FLAG, STOCK_VIEW_DEFAULT)).toLowerCase()
    const g = str(rd(STOCK_GROUP_FLAG, STOCK_GROUP_DEFAULT)).toLowerCase()
    const z = str(rd(STOCK_ZONE_SRC_FLAG, STOCK_ZONE_SRC_DEFAULT)).toLowerCase()
    return { view: STOCK_VIEWS[v] ? v : (v === 'now' ? 'now' : STOCK_VIEW_DEFAULT), group: STOCK_GROUP_MODES[g] ? g : STOCK_GROUP_DEFAULT,
        zoneSrc: z === 'zone_engine' ? 'zone_engine' : 'zone', ...(/^g\d$/.test(g) && STOCK_GROUP_MODES[g] ? { calm: stockGroupCalm_read(rd) } : {}) }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: объединение зон групп складов G1–G5; BE n_by_zone #1013): calm — только у G1–G5
}
// группы полей запроса: Z4 — ещё нормы в днях (dos_norms)
export function stockCells_fields(view) { return view === 'z4' ? ['flow', 'norms', 'zone', 'dos_norms'] : ['flow', 'norms', 'zone'] }

// ---------- строки запаса в дереве ----------
// отбор строки: _DLRow.where [{leftValue, rightValue}] (как cellPassport_rowWhere) и прямые поля строки — запасной путь
function ownDims(it) {
    const d = {}
    const wh = isObj(it) && isObj(it._DLRow) && Array.isArray(it._DLRow.where) ? it._DLRow.where : []
    for (const w of wh) {
        const k = str(w && (isObj(w.leftValue) ? w.leftValue.value : w.leftValue))
        const v = w && (isObj(w.rightValue) ? w.rightValue.value : w.rightValue)
        if (k && v !== undefined && v !== null && v !== '' && typeof v !== 'object' && !(k in d)) d[k] = str(v)
    }
    for (const k of ['measure_type', 'object', 'subject']) if (!(k in d) && isObj(it) && (typeof it[k] === 'string' || typeof it[k] === 'number') && str(it[k])) d[k] = str(it[k])
    return d
}
// индекс строк запаса: data — массив корня _doc.data, childKey — путь детей ('attrs'). → Map(item → info):
// info = { path, object, subjects: [GUID], kids: [item], total, leaf, depth } — только строки запаса без псевдострочек
export function stockRows_index(data, childKey = 'attrs', toRawFn = (x) => x) {
    const out = new Map()
    const walk = (arr, prefix, parentEff, parentSubject, depth) => {
        if (!Array.isArray(arr)) return []
        const subjectsAll = []
        arr.forEach((raw, i) => {
            const it = toRawFn(raw)
            if (!isObj(it)) return
            const path = prefix ? `${prefix}.${i}` : String(i)
            const own = ownDims(it)
            const eff = Object.assign({}, parentEff, own)
            const pseudo = !!parentSubject || ('subject' in own && !stock_isSubjectId(own.subject))   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129289): числовой subject — не псевдострочка
            const stock = eff.measure_type === 'open_balance' && !pseudo
            const subj = stock && stock_isSubjectId(eff.subject) ? eff.subject : ''   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129289)
            const kids = it[childKey]
            const kidSubjects = walk(kids, path, eff, parentSubject || subj, depth + 1)
            if (!stock) { subjectsAll.push(...kidSubjects); return }
            const subjects = subj ? [subj] : [...new Set(kidSubjects)]
            const info = { path, object: str(eff.object), subjects, kids: [], total: 'measure_type' in own, leaf: !!subj, depth }
            if (Array.isArray(kids)) for (const k of kids) { const kk = toRawFn(k); if (out.has(kk)) info.kids.push(kk) }
            out.set(it, info)
            subjectsAll.push(...subjects)
        })
        return subjectsAll
    }
    walk(data, '', {}, '', 0)
    return out
}
// строка запроса по info (нет объекта / листьев — null)
export function stockRows_req(info) {
    if (!info || !info.path || !info.object || !info.subjects || !info.subjects.length) return null
    return { path: info.path, object: info.object, subjects: info.subjects.slice() }
}
// следующая порция: queue — [info] (с головы), skip(path) → true (уже в кеше / в полёте). Потолки: rows ≤ size, пар ≤ pairsMax (строка крупнее — одна)
export function stockRows_portion(queue, size = STOCK_PORTION, skip = null, pairsMax = STOCK_PAIRS_MAX) {
    const out = [], seen = new Set()
    let pairs = 0
    while (Array.isArray(queue) && queue.length && out.length < size) {
        const r = stockRows_req(queue[0])
        if (!r || seen.has(r.path) || (skip && skip(r.path))) { queue.shift(); continue }
        if (out.length && pairs + r.subjects.length > pairsMax) break
        queue.shift(); seen.add(r.path); pairs += r.subjects.length
        out.push(r)
    }
    return out
}
// параметры вызова (контракт §4)
export function stockCells_params(rows, dates, fields, budgetMs = STOCK_BUDGET_MS) {
    const ds = (Array.isArray(dates) ? dates : []).filter(d => /^\d{4}-\d{2}-\d{2}$/.test(d)).sort()
    const p = { version: '', fields: (fields || stockCells_fields('z5')).slice(), budget_ms: budgetMs, rows }
    if (ds.length) { p.date_from = ds[0]; p.date_to = ds[ds.length - 1] }
    return p
}
// объект метода из ответа executeWidgetMethod | null (старый бэк без метода)
export function stockCells_answerOf(answer) {
    const b = isObj(answer) ? answer[STOCK_CELLS_METHOD] : null
    return isObj(b) ? b : null
}
// слить ответ в кеш: cache — Map(path → {date: raw}); paths — отправленные. → { off, ok: [path], retry: [path] }
// строка без ячеек — пустой объект (рисовать нечего, повторно не шлём); truncated — в retry; state 'off' / нет метода — off
export function stockCells_merge(cache, paths, answer) {
    const b = stockCells_answerOf(answer)
    if (!b || b.state !== 'ok') return { off: true, ok: [], retry: [], state: b ? str(b.state) : 'no method' }
    const rows = isObj(b.rows) ? b.rows : {}
    const trunc = new Set(Array.isArray(b.truncated) ? b.truncated.map(String) : [])
    const ok = [], retry = []
    for (const p of paths || []) {
        if (trunc.has(p)) { retry.push(p); continue }
        cache.set(p, isObj(rows[p]) ? rows[p] : {})
        ok.push(p)
    }
    return { off: false, ok, retry, state: 'ok' }
}

// ---------- модель ячейки ----------
const ZONE_ALIAS = { no_sales: 'no', dead: 'no', none: 'no', optimal: 'ok', critical: 'min', replenishment: 'opt', maximum: 'max', over_norm: 'excess' }
export const ZRANK = { oos: 0, min: 1, opt: 2, excess: 3, max: 4, ok: 5, no: 6 }
export function stock_zoneNorm(z) { const k = str(z).toLowerCase(); const a = ZONE_ALIAS[k] || k; return Object.prototype.hasOwnProperty.call(ZRANK, a) ? a : '' }
export function stock_zoneOf(v, th, act = true) {
    if (!act) return 'no'
    if (v < 0) return 'oos'
    if (!(th[0] > 0 || th[1] > 0 || th[2] > 0)) return 'no'   // норм нет — «без продаж»
    if (v < th[0]) return 'min'
    if (v < th[1]) return 'opt'
    if (v <= th[2]) return 'ok'
    if (v <= th[3]) return 'max'
    return 'excess'
}
// raw — ячейка ответа (нулевых полей нет: отсутствие = 0), zoneSrc — 'zone' | 'zone_engine'. → модель | null (пустая ячейка)
export function stockCell_model(raw, zoneSrc = 'zone') {
    if (!isObj(raw)) return null
    const start = num(raw.start), inn = num(raw.in), out = num(raw.out), wo = num(raw.wo), adj = num(raw.adj), short = num(raw.short)
    const end = raw.end !== undefined ? num(raw.end) : start + inn - out - wo + adj
    const endRaw = raw.end_raw !== undefined ? num(raw.end_raw) : end - short
    const mn = num(raw.min), op = num(raw.opt), mx = num(raw.max)
    const exNull = raw.excess === null
    const ex = exNull || !(num(raw.excess) > 0) ? (mx > 0 ? mx * 1.5 : 0) : num(raw.excess)
    const zSrc = zoneSrc === 'zone_engine' && raw.zone_engine ? raw.zone_engine : raw.zone
    const act = !!(start || inn || out || wo || adj || short || end || endRaw || mn || op || mx)   // контракт §14.1: активен и лист с одним end
    if (!act) return null
    const dos = ['dos_min', 'dos_opt', 'dos_max', 'dos_excess'].map(k => num(raw[k]))
    return { start, in: inn, out, wo, adj, end, short, endRaw, peak: start + inn, th: [mn, op, mx, ex], exNull, zone: stock_zoneNorm(zSrc),
        zoneEngine: stock_zoneNorm(raw.zone_engine), zoneMain: stock_zoneNorm(raw.zone), leaves: num(raw.leaves), nOos: num(raw.n_oos), nCrit: num(raw.n_crit),
        split: !!raw.split, dos: dos.some(x => x > 0) ? dos : null, act, nbz: isObj(raw.n_by_zone) ? raw.n_by_zone : null }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: объединение зон групп складов G1–G5; BE n_by_zone #1013): nbz — n_by_zone группы
}
// значение кривой в момент t ∈ [0, 1]: вход → пик (середина) → выход
export function stock_vAt(m, t) {
    const a = m.start, p = m.peak, b = m.endRaw
    return t <= SPLIT ? a + (p - a) * t / SPLIT : p + (b - p) * (t - SPLIT) / (1 - SPLIT)
}

// ---------- шкалы видов (эскиз stock3.html): v (шт.) → y (единицы эскиза) ----------
const lin = (v, a, b, ya, yb) => (b <= a ? yb : ya + (v - a) / (b - a) * (yb - ya))
const soft = (v, x0, y0, yTop, k) => { const R = y0 - yTop; return !isFinite(k) || k <= 0 ? yTop : y0 - R * (1 - Math.exp(-(v - x0) * k / R)) }
export const Z5L = { oos: 24.4, min: 18, opt: 18, ok: 12, max: 6, excess: 6, no: 12 }
const LAY = { z1: { op: 15, mx: 8, ex: 3.5, top: 0.8 }, z2: { op: 17.5, mx: 5.5, ex: 3, top: 0.8 }, z6: { mn: 17, ex: 4, top: 0.8 } }
export const NORM_DAYS = [15, 30, 60, 90]
// Z4: нормы в днях (dos_* ответа, иначе 15 / 30 / 60 / 90) и дневной спрос: opt / dos_opt, иначе расход месяца / 30
function z4Of(m) {
    const nd = m.dos && m.dos[1] > 0 ? m.dos : NORM_DAYS
    const d = m.th[1] > 0 && nd[1] > 0 ? m.th[1] / nd[1] : (m.out > 0 ? m.out / 30 : 0)
    return { nd, d }
}
function thFor(view, m) { if (view !== 'z4') return m.th; const { nd, d } = z4Of(m); return nd.map(x => x * d) }
export function stock_yMap(view, v, th, z, m) {
    const [mn, op, mx, ex] = th
    if (view === 'z5') return Z5L[z] ?? 12
    if (v < 0) return ZB + Math.min(3.6, 1.6 + 2.0 * (-v) / Math.max(1, mn))
    switch (view) {
    case 'z1': case 'z2': {
        const Y = LAY[view]
        if (v < op) return lin(v, 0, op, ZB, Y.op)
        if (v <= mx) return lin(v, op, mx, Y.op, Y.mx)
        if (v <= ex) return lin(v, mx, ex, Y.mx, Y.ex)
        return soft(v, ex, Y.ex, Y.top, (Y.mx - Y.ex) / (ex - mx))
    }
    case 'z6': {
        const Y = LAY.z6
        if (v < mn) return lin(v, 0, mn, ZB, Y.mn)
        if (v <= ex) return lin(v, mn, ex, Y.mn, Y.ex)
        return soft(v, ex, Y.ex, Y.top, (Y.mn - Y.ex) / (ex - mn))
    }
    case 'z3': {
        if (op <= 0) return 1
        if (v < op / 4) return lin(v, 0, op / 4, ZB, 21)
        return Math.max(1, 11 - 5 * Math.log2(v / op))
    }
    case 'z4': {
        const { nd, d } = z4Of(m || { th, dos: null, out: 0 })
        const top = nd[3] || 90
        const D = d > 0 ? v / d : (v > 0 ? 1e9 : 0)
        if (D <= top) return ZB - D * 19 / top
        return soft(D, top, 3, 0.8, 19 / top)
    }
    }
    return 12
}
// направляющие вида: { lines: [[y, 'band' | 'thr']], corr: [y1, y2] | null }
function guides(view, th, m) {
    const Y = (v) => stock_yMap(view, v, th, stock_zoneOf(v, th, true), m)
    switch (view) {
    case 'z1': case 'z2': { const L = LAY[view]; return { lines: [[L.op, 'band'], [L.mx, 'band'], [L.ex, 'thr']], corr: [L.mx, L.op] } }
    case 'z6': return { lines: [[LAY.z6.mn, 'band'], [LAY.z6.ex, 'band']], corr: [Y(th[2]), Y(th[1])] }
    case 'z3': return th[1] > 0 ? { lines: [[11, 'band'], [Y(th[0]), 'thr'], [Y(th[3]), 'thr']], corr: [Y(th[2]), 11] } : { lines: [], corr: null }
    case 'z4': { const { nd } = z4Of(m); const top = nd[3] || 90; return { lines: nd.map((x, j) => [ZB - x * 19 / top, j === 1 || j === 2 ? 'band' : 'thr']), corr: [ZB - nd[2] * 19 / top, ZB - nd[1] * 19 / top] } }
    case 'z5': return { lines: [[18, 'thr'], [12, 'band'], [6, 'thr']], corr: null }
    }
    return { lines: [], corr: null }
}

// ---------- цвета: монохром, цвет только у OOS / Critical / Over-norm ----------
export const STOCK_COLORS = Object.freeze({ oos: '#e53935', min: '#f08c00', excess: '#2e7d32', gray: '#8d96a0', no: '#c2c6cc', base: '#b9bdc5', in: '#4b5563',
    corr: 'rgba(110,118,130,.085)', guide: 'rgba(60,66,76,.16)', fOos: 'rgba(239,83,80,.42)', fMin: 'rgba(255,169,77,.40)', fExcess: 'rgba(46,125,50,.30)',
    fGray: 'rgba(141,150,160,.17)', fNo: 'rgba(158,158,158,.12)' })
const C = STOCK_COLORS
const LC = { oos: C.oos, min: C.min, opt: C.gray, ok: C.gray, max: C.gray, excess: C.excess, no: C.no }
const FC = { oos: C.fOos, min: C.fMin, opt: C.fGray, ok: C.fGray, max: C.fGray, excess: C.fExcess, no: C.fNo }
const LC5 = { oos: C.oos, min: C.min, opt: C.gray,   // монохром: Replenishment — серый (в эскизе — бледно-оранжевый)
    ok: C.gray, max: C.gray, excess: C.gray, no: C.no }
const STRIP = { oos: C.oos, min: C.min, opt: C.gray, ok: C.no, max: C.gray, excess: C.in, no: C.no }

// ---------- отрезки кривой по зонам ----------
const SAMPLES = 22
// моменты t: равномерно + середина + точные пересечения нуля и порогов
function curveTs(models, thOf) {
    const ts = new Set([0, SPLIT, 1])
    for (let k = 1; k < SAMPLES; k++) ts.add(k / SAMPLES)
    for (const q of models) {
        const th = thOf(q)
        for (const [t0, t1] of [[0, SPLIT], [SPLIT, 1]]) {
            const a = stock_vAt(q, t0), b = stock_vAt(q, t1)
            for (const L of [0, ...th]) if ((a - L) * (b - L) < 0) ts.add(t0 + (L - a) / (b - a) * (t1 - t0))
        }
    }
    return [...ts].sort((a, b) => a - b)
}
// отрезки [x0, x1, z] по функции зоны момента; последний отрезок — зона ответа (lastZone), если задана и выход не OOS
export function stock_segs(zAt, ts, lastZone = '') {
    const out = []
    for (let j = 1; j < ts.length; j++) {
        if (ts[j] - ts[j - 1] < 1e-9) continue
        const z = zAt((ts[j - 1] + ts[j]) / 2), x0 = f1(ts[j - 1] * W), x1 = f1(ts[j] * W)
        if (out.length && out[out.length - 1][2] === z) out[out.length - 1][1] = x1; else out.push([x0, x1, z])
    }
    if (lastZone && out.length && out[out.length - 1][2] !== 'oos' && lastZone !== 'oos') out[out.length - 1][2] = lastZone
    else if (lastZone === 'oos' && out.length) out[out.length - 1][2] = 'oos'
    return out
}
const zAtOf = (view, m) => (t) => stock_zoneOf(stock_vAt(m, t), thFor(view, m), true)
const lastZ = (m) => (m.zoneLast !== undefined ? m.zoneLast : m.zone)
const sumSegs = (m, view = 'z5') => stock_segs(zAtOf(view, m), curveTs([m], (q) => thFor(view, q)), lastZ(m))
const LV = { oos: 0, min: 1, opt: 1, ok: 2, max: 3, excess: 3, no: 2 }
const worse = (a, b) => LV[a] < LV[b] || (LV[a] === LV[b] && ZRANK[a] < ZRANK[b])

// ступенька зон (Z5): уровень = зона, переходы — тонкие серые
function stepLayers(segs, Y, sw = 1.4) {
    const L = []
    segs.forEach(([x0, x1, z], j) => {
        const y = Y(z)
        L.push({ k: 'line', x1: x0, y1: y, x2: x1, y2: y, stroke: LC5[z] || C.gray, sw: z === 'min' || z === 'oos' ? sw * 1.57 : sw, op: z === 'opt' ? 0.65 : 1 })
        const n = segs[j + 1]
        if (n) L.push({ k: 'line', x1, y1: y, x2: x1, y2: Y(n[2]), stroke: C.gray, sw: 0.7 })
    })
    return L
}
const baseLine = () => ({ k: 'line', x1: 0, y1: ZB, x2: W, y2: ZB, stroke: C.base, sw: 0.7 })
const oosBand = (segs, h = 4) => segs.filter(s => s[2] === 'oos').map(([x0, x1]) => ({ k: 'rect', x: x0, y: ZB, w: Math.max(1, x1 - x0), h, fill: C.fOos }))

// ---------- реестр видов ----------
const ZT = { oos: 'OOS', min: 'Critical', opt: 'Replenishment', ok: 'Optimal', max: 'Maximum', excess: 'Over-norm', no: 'Without sales' }
export const stock_zoneTitle = (z, t = tI18n) => (ZT[z] ? t(ZT[z], undefined, STOCK_ZONE_CTX) : '')   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р6/Р7): «Over-norm|stock zone» и т. п. — на uk / ru по-своему (голое «Critical» — «Критично» для других мест)
function viewZ5(cell) {
    const segs = sumSegs(cell, 'z5')
    return { layers: [...guidesLayers('z5', cell.th, cell), baseLine(), ...oosBand(segs), ...stepLayers(segs, (z) => Z5L[z] ?? 12)], title: stock_zoneTitle(cell.zone || (segs.length ? segs[segs.length - 1][2] : '')) }
}
function guidesLayers(view, th, m) {
    const g = guides(view, th, m), L = []
    if (g.corr && g.corr[1] > g.corr[0]) L.push({ k: 'rect', x: 0, y: g.corr[0], w: W, h: g.corr[1] - g.corr[0], fill: C.corr })
    for (const [y, k] of g.lines) L.push({ k: 'line', x1: 0, y1: y, x2: W, y2: y, stroke: C.guide, sw: 0.6, dash: k === 'thr' ? '1.5 2' : '' })
    return L
}
// кривая с заливкой по зонам (Z1 / Z2 / Z3 / Z4 / Z6)
function viewCurve(view) {
    return (cell) => {
        const th = thFor(view, cell)
        const ts = curveTs([cell], (q) => thFor(view, q))
        const segs = stock_segs(zAtOf(view, cell), ts, lastZ(cell))
        const P = ts.map(t => { const v = stock_vAt(cell, t); const y = stock_yMap(view, v, th, stock_zoneOf(v, th, true), cell); return { X: f1(t * W), y: f1(Math.max(0.8, Math.min(H - 0.6, y))) } })
        const fills = [], lines = [], bands = []
        for (const [x0, x1, z] of segs) {
            const pts = P.filter(p => p.X >= x0 - 1e-6 && p.X <= x1 + 1e-6).map(p => [p.X, p.y])
            if (pts.length < 2) continue
            fills.push({ k: 'area', pts, y0: ZB, fill: FC[z] || C.fGray })
            lines.push({ k: 'poly', pts, stroke: LC[z] || C.gray, sw: 1.4 })
            if (z === 'oos') bands.push({ k: 'rect', x: x0, y: ZB, w: Math.max(1, x1 - x0), h: 1.6, fill: C.oos })
        }
        return { layers: [...guidesLayers(view, th, cell), ...fills, baseLine(), ...bands, ...lines], title: stock_zoneTitle(cell.zone || (segs.length ? segs[segs.length - 1][2] : '')) }
    }
}
// STOCK_VIEWS: id → (cell, neighbours, rowScale, size) → { layers, title }. 'now' — без слоя (как сейчас)
export const STOCK_VIEWS = {
    now: () => ({ layers: [], title: '' }),
    z1: viewCurve('z1'),   // «4 смуги»
    z2: viewCurve('z2'),   // «Норма в центрі»
    z3: viewCurve('z3'),   // «Відносно оптимуму»
    z4: viewCurve('z4'),   // «Дні покриття»
    z5: viewZ5,            // «Тільки зона» — по умолчанию
    z6: viewCurve('z6'),   // «Смуги уваги»
    ...stockViews2({ W, H, SPLIT, C: STOCK_COLORS, vAt: stock_vAt, zoneOf: stock_zoneOf, segs: stock_segs, curveTs, zoneTitle: stock_zoneTitle }),   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса P/P2/Q/R/S/T/U/U2/U4/U5): p, p2, q, r, s, t, u, u2, u4, u5
}

// ---------- режимы групп (эскиз stock4.html) ----------
// neighbours: { kids: [model | null], total: итоговый уровень (корень строки запаса), collapsed: детей не видно / не загружены }
const kidsOf = (nb) => (nb && Array.isArray(nb.kids) && nb.kids.length && !nb.collapsed && nb.kids.every(Boolean) ? nb.kids : null)
function kidTs(kids) { return curveTs(kids, (q) => q.th) }
function worstSegs(kids) { return stock_segs((t) => { let b = null; for (const q of kids) { const z = stock_zoneOf(stock_vAt(q, t), q.th, true); if (!b || worse(z, b)) b = z } return b || 'no' }, kidTs(kids)) }
function alertSegs(kids) { return stock_segs((t) => { let a = null; for (const q of kids) { const z = stock_zoneOf(stock_vAt(q, t), q.th, true); if (z === 'oos') a = 'oos'; else if (z === 'min' && a !== 'oos') a = 'min' } return a }, kidTs(kids)) }
function overSegs(kids) { return stock_segs((t) => kids.some(q => stock_zoneOf(stock_vAt(q, t), q.th, true) === 'excess') || null, kidTs(kids)) }
const whole = (z) => (z ? [[0, W, z]] : [])
// C: полоса долей на выходе месяца (3 px внизу): items [{ z, units, n }]
function stripLayers(items) {
    const X0 = 1, X1 = W - 1, gap = 1, L = []
    const fixed = items.filter(it => it.units <= 0), prop = items.filter(it => it.units > 0)
    const fixedW = fixed.reduce((s, it) => s + 3 * it.n + (it.n - 1) * gap, 0), tot = prop.reduce((s, it) => s + it.units, 0)
    const free = Math.max(0, X1 - X0 - fixedW - gap * Math.max(0, items.length - 1))
    let x = X0
    for (const it of items) {
        const w = it.units <= 0 ? 3 * it.n + (it.n - 1) * gap : Math.max(1.5, tot > 0 ? free * it.units / tot : 0)
        if (x >= X1) break
        L.push({ k: 'rect', x, y: 23, w: Math.min(w, X1 - x), h: 3, fill: STRIP[it.z] || C.no })
        x += w + gap
    }
    return L
}
const ZORD = ['oos', 'min', 'opt', 'ok', 'max', 'excess', 'no']
function stripItems(cell, kids) {
    if (kids) return kids.map(q => ({ z: q.zone || stock_zoneOf(q.endRaw, q.th, true), units: Math.max(0, q.endRaw), n: 1 })).sort((a, b) => ZORD.indexOf(a.z) - ZORD.indexOf(b.z))
    const rest = Math.max(0, cell.leaves - cell.nOos - cell.nCrit), out = []   // свёрнуто: доли по числу листов (штук по зонам в ответе нет)
    if (cell.nOos) out.push({ z: 'oos', units: cell.nOos, n: cell.nOos })
    if (cell.nCrit) out.push({ z: 'min', units: cell.nCrit, n: cell.nCrit })
    if (rest) out.push({ z: 'ok', units: rest, n: rest })
    return out
}
function dotLayer(cx, n, fill) { return { k: 'dot', cx, cy: 20.6, r: 4.3, fill, text: String(n) } }
const baseOf = (ctx) => STOCK_VIEWS[(ctx && ctx.view) || 'z5'] || viewZ5
export const STOCK_GROUP_MODES = {
    a: (cell, nb, rs, size, ctx) => baseOf(ctx)(cell, nb, rs, size),   // «сума»
    b: (cell, nb) => {   // «найгірша»: худшая зона листов в каждый момент
        const kids = kidsOf(nb), segs = kids ? worstSegs(kids) : whole(cell.zone || 'no')
        return { layers: [baseLine(), ...oosBand(segs), ...stepLayers(segs, (z) => Z5L[z] ?? 12)], title: stock_zoneTitle(segs.length ? segs[segs.length - 1][2] : '') }
    },
    c: (cell, nb) => {   // «смуга часток»: ступенька суммы + полоса долей листов по зонам на выходе
        const segs = sumSegs(cell, 'z5'), kids = kidsOf(nb)
        return { layers: [baseLine(), ...stepLayers(segs, (z) => (z === 'oos' ? 20.8 : (Z5L[z] ?? 12))), ...stripLayers(stripItems(cell, kids))], title: stock_zoneTitle(cell.zone) }
    },
    d: (cell, nb, rs, size, ctx) => {   // «сума + сигнали»: число листов в OOS / Critical (красная метка) и в Over-norm (тёмная)
        const r = baseOf(ctx)(cell, nb, rs, size), kids = kidsOf(nb)
        const nAlert = kids ? kids.filter(q => q.zone === 'oos' || q.zone === 'min' || q.endRaw < 0).length : cell.nOos + cell.nCrit
        const nOver = kids ? kids.filter(q => (q.zone || stock_zoneOf(q.endRaw, q.th, true)) === 'excess').length : 0
        let cx = W - 5.2
        const L = r.layers.slice()
        if (nAlert) { L.push(dotLayer(cx, nAlert, C.oos)); cx -= 9.8 }
        if (nOver) L.push(dotLayer(cx, nOver, C.in))
        return { layers: L, title: r.title }
    },
    e: (cell, nb, rs, size, ctx) => {   // «стос»: ступеньки детей одна под другой (детей ≤ 4, иначе — C)
        const kids = kidsOf(nb)
        if (!kids || kids.length > 4) return STOCK_GROUP_MODES.c(cell, nb, rs, size, ctx)
        if (kids.length <= 1) return viewZ5(cell)
        const lh = 24 / kids.length, F = { oos: 0.9, min: 0.66, opt: 0.66, ok: 0.42, max: 0.16, excess: 0.16, no: 0.42 }, L = []
        kids.forEach((q, j) => {
            const y0 = 1 + j * lh
            if (j) L.push({ k: 'line', x1: 0, y1: y0 - 0.5, x2: W, y2: y0 - 0.5, stroke: C.guide, sw: 0.6 })
            L.push(...stepLayers(sumSegs(q, 'z5'), (z) => y0 + lh * (F[z] ?? 0.42), 1.3))
        })
        return { layers: L, title: stock_zoneTitle(cell.zone) }
    },
    f: (cell, nb, rs, size, ctx) => {   // «сума + кайма»: снизу кайма OOS (красная) / Critical (оранжевая), сверху пунктир Over-norm; итог — только красная OOS
        const r = baseOf(ctx)(cell, nb, rs, size), kids = kidsOf(nb), total = !!(nb && nb.total)
        let al = kids ? alertSegs(kids) : whole(cell.nOos > 0 || cell.endRaw < 0 ? 'oos' : (cell.nCrit > 0 ? 'min' : null))
        if (total) al = al.filter(s => s[2] === 'oos')
        const ov = total ? [] : (kids ? overSegs(kids) : whole(cell.zone === 'excess' ? true : null))
        const L = r.layers.slice()
        for (const [x0, x1, z] of al) if (z) L.push({ k: 'rect', x: x0, y: 24, w: Math.max(1, x1 - x0), h: 2, fill: z === 'oos' ? C.oos : C.min })
        for (const [x0, x1, z] of ov) if (z) L.push({ k: 'line', x1: x0 + 1, y1: 1.6, x2: x1 - 1, y2: 1.6, stroke: C.in, sw: 1.4, dash: '3 2' })
        return { layers: L, title: r.title }
    },
    ...stockGroupModes2_modes(),   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: объединение зон групп складов G1–G5; BE n_by_zone #1013): g1 … g5 — utils/stockGroupModes2.js
}

// ---------- SVG-слой ----------
// полоса кривой — нижняя часть ячейки (число по центру не перечёркивается; снимок 26 px: при 42 % верх кривой задевал цифры): высота ≈ 36 % строки, 8…12 px
// IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р6/Р7): низкая строка (≤ STOCK_LOW_ROW px; гейт: 17 px — полоса 8 px, линия Z5 задевала низ цифр) — полоса по высоте ячейки:
// цифры по центру (шрифт ≈ 0,7 высоты строки, не больше 12 px), низ цифр ≈ h/2 + 0,36·шрифт; верхний уровень Z5 (max / excess — 6 из 26 единиц эскиза)
// ложится не выше низа цифр → высота полосы (h − низ цифр) / (1 − 6/26), 4…6 px. sw — множитель толщины линий (на тонкой полосе линии тоньше)
export const STOCK_LOW_ROW = 18
export function stockCell_band(h) {
    const rh = Number(h) > 0 ? Number(h) : 24
    if (rh > STOCK_LOW_ROW) { const bandH = Math.max(8, Math.min(12, Math.round(rh * 0.36))); return { bandH, top: rh - bandH, textBottom: null, low: false, sw: 1 } }
    const fs = Math.min(12, rh * 0.7), textBottom = rh / 2 + 0.36 * fs
    const bandH = Math.max(4, Math.min(6, Math.floor((rh - textBottom) / (1 - Z5L.max / H))))
    return { bandH, top: rh - bandH, textBottom, low: true, sw: Math.min(1, bandH / 8) }
}
export function stockCell_bandH(h) { return stockCell_band(h).bandH }
const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
// layers (единицы эскиза) → строка SVG размера w × h px (h — высота полосы)
export function stockCell_svg(layers, w, h, o = {}) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р6/Р7): o.sw — множитель толщины линий (низкая строка), o.op — непрозрачность всего слоя (строка-итог / группа)
    const sx = (Number(w) || W) / W, sy = (Number(h) || H) / H, X = (x) => f1(x * sx), Y = (y) => f1(y * sy)
    const k = Number(o.sw) > 0 ? Number(o.sw) : 1, SW = (v) => f1(Math.max(0.5, v * k))
    let s = ''
    for (const l of layers || []) {
        if (l.k === 'rect') s += `<rect x="${X(l.x)}" y="${Y(l.y)}" width="${f1(Math.max(0.5, l.w * sx))}" height="${f1(Math.max(0.5, l.h * sy))}" fill="${l.fill}"/>`
        else if (l.k === 'line') s += `<line x1="${X(l.x1)}" y1="${Y(l.y1)}" x2="${X(l.x2)}" y2="${Y(l.y2)}" stroke="${l.stroke}" stroke-width="${SW(l.sw)}"${l.dash ? ` stroke-dasharray="${l.dash}"` : ''}${l.op && l.op < 1 ? ` stroke-opacity="${l.op}"` : ''} stroke-linecap="round"/>`
        else if (l.k === 'poly') s += `<polyline points="${l.pts.map(p => `${X(p[0])},${Y(p[1])}`).join(' ')}" fill="none" stroke="${l.stroke}" stroke-width="${SW(l.sw)}" stroke-linejoin="round" stroke-linecap="round"/>`
        else if (l.k === 'area') { const p = l.pts; s += `<polygon points="${p.map(q => `${X(q[0])},${Y(q[1])}`).join(' ')} ${X(p[p.length - 1][0])},${Y(l.y0)} ${X(p[0][0])},${Y(l.y0)}" fill="${l.fill}"/>` }
        else if (l.k === 'text') { const fs = f1(Math.max(6, Math.min(8, h * 0.75))), ty = f1(Math.max(fs * 0.8, Math.min(h - 0.3, Y(l.y)))); s += `<text x="${X(l.x)}" y="${ty}" font-size="${fs}" font-family="sans-serif" font-weight="600" fill="${l.fill}" stroke="#fff" stroke-width="2" stroke-linejoin="round" paint-order="stroke" text-anchor="${l.anchor || 'start'}">${esc(l.text)}</text>` }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса P/P2/Q/R/S/T/U/U2/U4/U5): подписи U2 / U5 «+40k»
        else if (l.k === 'dot') { const r = f1(l.r * Math.min(sx, sy) * 1.3); s += `<circle cx="${X(l.cx)}" cy="${f1(Math.min(h - r - 0.3, Y(l.cy)))}" r="${r}" fill="${l.fill}" stroke="#fff" stroke-width="1"/><text x="${X(l.cx)}" y="${f1(Math.min(h - r - 0.3, Y(l.cy)) + r * 0.6)}" font-size="${f1(r * 1.5)}" font-family="sans-serif" font-weight="700" fill="#fff" text-anchor="middle">${esc(l.text)}</text>` }
    }
    if (Number(o.op) > 0 && Number(o.op) < 1) s = `<g opacity="${o.op}">${s}</g>`   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р6/Р7)
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${f1(w)}" height="${f1(h)}" viewBox="0 0 ${f1(w)} ${f1(h)}">${s}</svg>`
}
export function stockCell_url(svg) { return `url("data:image/svg+xml,${encodeURIComponent(svg)}")` }
// IE 2026 11 03 / ODOO-350449 (проба p259: стык после дефицита — сброс к 0 пунктиром): ключ предыдущего месяца ('2027-01-01' → '2026-12-01') и end_raw < 0 предыдущего месяца строки (nb.prevRaw — его сырая
// ячейка) — виды с линией рисуют у левого края «сброс к 0»; иначе null
export function stock_prevMonth(d) {
    const m = /^(\d{4})-(\d{2})(.*)$/.exec(String(d || ''))
    if (!m) return ''
    const y = Number(m[1]), mo = Number(m[2])
    return mo === 1 ? `${y - 1}-12${m[3]}` : `${y}-${String(mo - 1).padStart(2, '0')}${m[3]}`
}
export function stock_prevEndRaw(nb) {
    const pm = nb && isObj(nb.prevRaw) ? stockCell_model(nb.prevRaw) : null
    return pm && pm.endRaw < 0 ? pm.endRaw : null
}
export const STOCK_QUIET_OP = 0.55   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р6/Р7): непрозрачность слоя строки-итога / группы
// слой ячейки: { img, bandH, title, quiet } | null (нечего рисовать). opts: { view, group, zoneSrc }, isGroup — строка-группа (режим группы), kids — сырые ячейки детей
export function stockCell_layer(raw, opts, size, nb = {}) {
    const o = opts || {}
    if (!o.view || o.view === 'now' || !STOCK_VIEWS[o.view]) return null
    const cell = stockCell_model(raw, o.zoneSrc)
    if (!cell) return null
    const w = Math.max(10, Math.round(Number(size && size.w) || W)), band = stockCell_band(size && size.h), bh = band.bandH   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р6/Р7): низкая строка — полоса ниже цифр
    cell.zoneLast = nb.isGroup ? '' : cell.zone   // группа: зона ответа — худшая среди листов, отрезки суммы — по её порогам
    const kr = Array.isArray(nb.kidsRaw) ? nb.kidsRaw : null   // ячейки детей: undefined — строка ребёнка не загружена
    const loaded = !!kr && kr.length > 0 && kr.every(k => k !== undefined)
    const neighbours = { kids: loaded ? kr.map(k => stockCell_model(k, o.zoneSrc)).filter(Boolean) : null, total: !!nb.total, collapsed: !!nb.collapsed || !loaded, prevEndRaw: stock_prevEndRaw(nb) }   // IE 2026 11 03 / ODOO-350449 (проба p259: стык после дефицита — сброс к 0 пунктиром): + prevEndRaw
    const fn = nb.isGroup ? (STOCK_GROUP_MODES[o.group] || STOCK_GROUP_MODES[STOCK_GROUP_DEFAULT]) : STOCK_VIEWS[o.view]
    const r = fn(cell, neighbours, nb.rowScale || null, { w, h: bh }, { view: o.view, calm: o.calm })   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: объединение зон групп складов G1–G5; BE n_by_zone #1013)
    if (!r || !r.layers || !r.layers.length) return null
    const quiet = !!(nb.isGroup || nb.total)   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р6/Р7): строка-итог / группа — слой тише (STOCK_QUIET_OP), цифры обычного цвета без ореола (класс stk-g в AttrGrid)
    return { img: stockCell_url(stockCell_svg(r.layers, w, bh, { sw: band.sw, op: quiet ? STOCK_QUIET_OP : 1 })), bandH: bh, title: r.title || '', quiet }
}
// ключ кеша слоя: вид, режим, источник зоны, значения, пороги (в raw), дети, ширина, высота
export function stockCell_key(raw, opts, size, nb = {}) {
    const o = opts || {}
    let k = `${o.view}|${nb.isGroup ? o.group + (o.calm === false ? ':loud' : '') : '-'}|${o.zoneSrc}|${Math.round(Number(size && size.w) || 0)}|${Math.round(Number(size && size.h) || 0)}|${nb.total ? 1 : 0}${nb.collapsed ? 1 : 0}|${JSON.stringify(raw)}`   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: объединение зон групп складов G1–G5; BE n_by_zone #1013): + calm
    if (nb.isGroup && Array.isArray(nb.kidsRaw)) k += '|' + nb.kidsRaw.map(x => (x === undefined ? '?' : JSON.stringify(x))).join(',')
    if (nb.rowScale) { const r = nb.rowScale; k += `|rs${r.hi},${r.lo},${r.level},${r.peak}` }
    const pe = stock_prevEndRaw(nb); if (pe !== null) k += `|pe${pe}`   // IE 2026 11 03 / ODOO-350449 (проба p259: стык после дефицита — сброс к 0 пунктиром)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса — общая шкала строки)
    return k
}

// ---------- Alt-подсказка ----------
const fmt = (v) => { const n = Math.round(Number(v) || 0); return (n < 0 ? '−' : '') + String(Math.abs(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') }
// → строка: вход · приход · расход · списание · корректировка · выход · дефицит · зона (и зона движка) · пороги; группа — листы в OOS / Critical
export function stockCell_tip(raw, opts = {}, t = tI18n) {
    const m = stockCell_model(raw, opts.zoneSrc)
    if (!m) return ''
    const parts = [`${t('Start')} ${fmt(m.start)}`, `${t('In')} ${fmt(m.in)}`, `${t('Out')} ${fmt(m.out)}`]
    if (m.wo) parts.push(`${t('Write-off')} ${fmt(m.wo)}`)
    if (m.adj) parts.push(`${t('Adjustment')} ${fmt(m.adj)}`)
    parts.push(`${t('End')} ${fmt(m.endRaw)}`)
    if (m.short) parts.push(`${t('Shortage (uncovered)')} ${fmt(m.short)}`)
    const z = m.zone || stock_zoneOf(m.endRaw, m.th, true)
    let zs = `${t('Zone')}: ${stock_zoneTitle(z, t)}`
    if (m.zoneEngine && m.zoneEngine !== m.zoneMain) zs += ` (${t('engine')}: ${stock_zoneTitle(m.zoneEngine, t)})`
    parts.push(zs)
    const nm = ['min', 'opt', 'max', 'excess'].map(k => t(k, undefined, 'norm')).join(' / ')   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р6/Р7): подписи порогов и счётчиков листов — через словарь (min|norm …, OOS|stock zone, Critical|stock zone)
    if (m.th[0] || m.th[1] || m.th[2]) parts.push(`${t('Thresholds')} ${nm}: ${m.th.slice(0, 3).map(fmt).join(' / ')} / ${m.exNull ? '—' : fmt(m.th[3])}`)
    if (m.leaves > 1) parts.push(`${t('Leaves')} ${m.leaves} · ${stock_zoneTitle('oos', t)} ${m.nOos} · ${stock_zoneTitle('min', t)} ${m.nCrit}`)
    if (m.split) parts.push(t('Curve of the whole node, number of its part'))
    return parts.join(' · ')
}
